// baseConfig.ts
import { getEnvironment } from "./environment-checks";
import { Config } from "./config";
var baseConfigName = "";
var baseConfig = new Config(baseConfigName, {
  ROOT_URL: {
    name: "ROOT_URL",
    env: true,
    client: true,
    required: true
  },
  MONGO_URL: {
    name: "MONGO_URL",
    env: true,
    client: false,
    required: true
  },
  DEPLOYMENT: {
    name: "DEPLOYMENT",
    env: true,
    client: true,
    required: false,
    defaultVal: "development"
  },
  ENVIRONMENT: {
    env: false,
    name: "ENVIRONMENT",
    client: true,
    value: getEnvironment()
  },
  DATADIR: {
    env: true,
    name: "DATADIR",
    client: false,
    required: false,
    defaultVal: "/datadir"
  },
  SERVER_SECRET: {
    env: true,
    name: "SERVER_SECRET",
    client: false,
    required: false,
    defaultVal: "supersecret"
  }
});
export {
  baseConfig
};
